export default __webpack_public_path__ + "static/media/link_off.ba71a5bd.svg";